'use client';

import RichText from '@/components/RichText';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import React, { ReactNode } from 'react';
import CustomRichText from '../CustomRichText';
export interface ProposalListBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  content: ReactNode | SerializedEditorState;
  card: {
    title: ReactNode | SerializedEditorState;
    btnContent: string;
    price: string;
    priceSuffix: string;
  };
}

export default function TxtWithCardBlock({ id, title, content, card }: ProposalListBlockProps) {
  return (
    <div
      id={id}
      data-meta="TxtWithCardBlock"
      className="container max-w-7xl mx-auto my-14 overflow-hidden"
    >
      <div className="px-4 py-5 sm:px-6 flex justify-center">
        <div className="text-4xl xl:text-8xl pb-4 text-center font-bold text-white">
          <CustomRichText data={title} tag="div" />
        </div>
      </div>
      <div className="py-4 mb-8 rounded-[2rem] flex flex-col md:grid md:grid-cols-12 lg:gap-4 justify-between gap-2">
        <div className="flex flex-col md:col-span-7 justify-between p-4 text-white">
          <CustomRichText data={content} tag="div" />
        </div>
        <div className="col-span-5 flex justify-center items-center bg-white max-h-fit rounded-3xl my-auto">
          <div className="flex flex-col lg:flex-row w-full justify-center items-center lg:items-baseline gap-8 p-4">
            <div className="ring-gray-200 rounded-3xl justify-between items-baseline bg-white">
              <div className="flex items-center justify-between gap-x-4">
                <div className="uppercase text-white rounded-full py-2 px-4 custom-gradient-green text-sm font-semibold 2xl:leading-8">
                  <CustomRichText data={card.title} tag="div" />
                </div>
              </div>
            </div>
            <div className="flex items-baseline gap-x-1">
              <div className="text-base xl:text-xl">
                <CustomRichText data={card.btnContent} tag="div" className="text-black" />
              </div>
              <div>
                <span className="text-5xl 2xl:text-6xl font-bold tracking-tight">
                  <span className="text-black">{card.price}</span>
                </span>
                <span className="text-xl font-semibold leading-6">
                  <span className="text-black">{card.priceSuffix}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
